'use client';

import type { PropsWithChildren, HTMLAttributes } from 'react';
import { cn } from '@packages/shared/src/utils/cn/cn';

export type CarouselProps = PropsWithChildren<HTMLAttributes<HTMLDivElement>>;

export const CarouselWrapper = ({ children, className, ...props }: CarouselProps) => (
  <div
    className={cn('bg-color-grey-light @container relative p-1.5 lg:p-2 lg:pb-2', className)}
    {...props}
  >
    {children}
  </div>
);
